import { ArbitrageModelRuleIdSchema as i } from "@hprofits/shared";
import { z as e } from "zod";
import { PaginationSchema as o, SortingSchema as r, paginatedList as n } from "../common/pagination.js";
import { idListQueryParam as s } from "../common/params.js";
const t = e.int().nullable(), a = e.object({
  id: i,
  // Legacy rows may have no name; rejecting them would fail the whole list.
  name: e.string().nullable(),
  filterByCountry: e.string().nullable(),
  filterByDeviceTypeId: t,
  filterByBrowserTypeId: t,
  filterByAdUnitId: t,
  filterByZoneId: t,
  filterByOsTypeId: t,
  filterByDspId: t,
  skipLastHours: e.int(),
  checkPeriodHours: e.int(),
  minImpressions: e.int(),
  minTotalImpressions: e.int(),
  minEvaluateHours: e.int(),
  stopLoseBalance: e.int(),
  stopTotalLoseBalance: e.int(),
  stopPeriodHours: e.int(),
  stopPeriodMultiplier: e.int(),
  hourlyRestorePercentIncrease: e.int()
}).readonly(), l = e.enum([
  "id",
  "name",
  "filterByCountry",
  "filterByZoneId",
  "skipLastHours",
  "checkPeriodHours",
  "minImpressions",
  "minTotalImpressions",
  "minEvaluateHours",
  "stopLoseBalance",
  "stopTotalLoseBalance",
  "stopPeriodHours",
  "stopPeriodMultiplier",
  "hourlyRestorePercentIncrease"
]), c = o.extend(r.shape).extend({
  sortBy: l.default("id"),
  ids: s(i).optional(),
  /** Comma-separated terms; a term that is a valid id also matches that id. */
  name: e.string().trim().min(1, "name must be non-empty").optional()
}).readonly(), y = n(a);
export {
  c as ArbitrageModelRuleListQuerySchema,
  y as ArbitrageModelRuleListSchema,
  a as ArbitrageModelRuleSchema,
  l as ArbitrageModelRuleSortBySchema
};
//# sourceMappingURL=schemas.js.map
